<script setup>
/**
 * GlobalFeaturePopup
 *
 * A single, app-root feature popup driven by Vuex geo state. Lets any part of the
 * app (e.g. a feature link inside a daily-review report) open a feature's popup on
 * the persistent map without owning a FeatureCollectionRenderer ref. Reuses the
 * standard FeaturePopup (incl. its "Open" button).
 */
import { computed } from 'vue'
import { useStore } from 'vuex'
import FeaturePopup from '@/components/feature/FeaturePopup.vue'

const store = useStore()

const popup = computed(() => store.getters['geo/getFeaturePopup'])
const map = computed(() => store.getters['geo/getMap'])
const settings = computed(() => store.getters['user/getUserSettings'] || { tz: 'UTC' })

const close = () => store.dispatch('geo/closeFeaturePopup')
</script>

<template>
  <FeaturePopup
    v-if="popup.visible && popup.feature && popup.coordinates && map"
    :map="map"
    :coordinates="popup.coordinates"
    :is-visible="popup.visible"
    :feature="popup.feature"
    :counter="popup.counter"
    :settings="settings"
    @close="close"
  />
</template>
